exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-content {\n    border: 1px solid #ddd;\n    padding: 10px;\n}\n.customer-content label {\n    margin: 0;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 1;\n}\n.customer-content p {\n    margin: 0;\n    margin-top: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/chatroom/chatroom.component.css
// module id = ../../../../../src/app/event/chatroom/chatroom.component.css
// module chunks = main